import "./generateUUID";
import "./getLanguage";
import "./handleLocalizationText";
import "./handleSelectOptions";
import "./replaceAccent";
import "./camelize";
import "./lowerCaseFirstLetter";
import "./customDateFormatForDatePrototype";
import "./toCurrencyFormat";
